/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";

import { _envParams } from "../../config/env_params";

import PrivateLayoutWeb from "./PrivateLayoutWeb";
import ScriptComponent from "./Component/ScriptComponent";

const PrivateLayout = (props) => {
  return (
    <PrivateLayoutWeb {...props} />
  );
}

export default PrivateLayout;
